import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import {
    CHANGE_SEARCH,
    SET_ITEMS,
    SELECT_RESULT
} from '@/store/actions/search';

const initialState = {
    query: '',
    items: [],
    selectedResult: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_SEARCH: {
            return { ...state, query: action.data.query };
        }

        case SET_ITEMS: {
            return { ...state, items: action.data.items };
        }

        case SELECT_RESULT: {
            return { ...state, selectedResult: action.data.result };
        }

        case AUTH_INVALIDATE:
        default: {
            return state;
        }
    }
};
